import { DatePicker } from "@blueprintjs/datetime";
import _ from "lodash";
import moment from "moment";
import { UserLanguage } from "../../../lang/lang";
import { FormItemBuilder } from "../Form";

const shortcuts = _.map([2, 3, 7, 14], (d) => ({
  date: moment()
    .hours(18)
    .minutes(0)
    .seconds(0)
    .milliseconds(0)
    .add(d, "d")
    .toDate(),
  label: UserLanguage().actions.days(d),
}));

export const DatePickerBuilder: FormItemBuilder<any> = (bundle) => {
  let value = null;

  if (bundle.field_current_value) value = new Date(bundle.field_current_value);
  else if (bundle.field_properties.defaultValue)
    value = new Date(bundle.field_properties.defaultValue);

  value?.setHours(18);
  value?.setMinutes(0);
  value?.setSeconds(0);
  value?.setMilliseconds(0);

  // console.log("scratch pad", bundle.scratch_pad);

  return (
    <DatePicker
      highlightCurrentDay
      shortcuts={shortcuts}
      onShortcutChange={(sc) => {
        // console.log("on sc change", sc);
        _.set(bundle.scratch_pad, [bundle.field_index, "sc"], sc);
      }}
      selectedShortcutIndex={(() => {
        // console.log("getting selected shortcut");
        // console.log("value", value);
        // console.log("shortcuts", shortcuts);

        const f = value
          ? _.findIndex(shortcuts, {
              date: value,
            })
          : undefined;

        return f === -1 ? undefined : f;
      })()}
      minDate={moment(new Date()).hours(18).minutes(0).toDate()}
      onChange={(newDate) => {
        // console.log("on change", newDate);
        _.unset(bundle.scratch_pad, [bundle.field_index, "sc"]);

        if (newDate === null) return;
        newDate.setHours(18);
        newDate.setMinutes(0);
        bundle.update_value(newDate);
      }}
      value={value}
      dayPickerProps={{
        canChangeMonth: true,
        disabledDays: [{ daysOfWeek: [0] }],
        firstDayOfWeek: 1,
      }}
    />
  );
};
